import React, { ErrorInfo, ReactNode } from 'react'
import ErrorPage from 'pages/ErrorPage'

export interface ErrorBoundaryProps {
  children: ReactNode
  customFallback?: ReactNode
  onError?: (error: Error, errorInfo: ErrorInfo) => void
}

export interface ErrorBoundaryState {
  hasError: boolean
  /** contains the error information tha we might wanna check against */
  error: Error | null
}

class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props)
    this.state = {
      hasError: false,
      error: null
    }
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    this.setState({ error })
    const { onError } = this.props
    onError?.(error, errorInfo)

    // eslint-disable-next-line no-console
    console.error('Uncaught error:', error, errorInfo)
  }

  render() {
    const { hasError, error } = this.state
    const { children, customFallback } = this.props

    if (hasError && error) {
      if (customFallback) {
        return customFallback
      }
      // You can render any custom fallback UI
      return <ErrorPage />
    }

    return children
  }
}
export default ErrorBoundary
